<template>
  <div class="notes-page">
    <NoteTaker />
  </div>
</template>

<script>
import NoteTaker from '@/components/NoteTaker/NoteTaker.vue';

export default {
  name: 'NotesPage',
  components: {
    NoteTaker
  }
};
</script>

<style scoped>
.notes-page {
  min-height: 100vh;
  width: 100%;
}
</style>
